// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a52224cb","513":"47dbb8b9","703":"e87620f6"}[chunkId] + ".chunk.js";
};